import {
    PUBLIC_CHAMELEON_CLIENT_API_URL,
    PUBLIC_CHAMELEON_V2_CLIENT_API_URL,
    PUBLIC_NARCO_CLIENT_API_URL,
    PUBLIC_NAUTILUS_CLIENT_API_URL,
    PUBLIC_NEO_CLIENT_API_URL,
    PUBLIC_PAM_CLIENT_API_URL,
    PUBLIC_SCR_CLIENT_API_URL,
    PUBLIC_SQUIDWARD_CLIENT_API_URL,
} from '@/app/_constants/urls'

import { ServiceName } from './types'

export const SERVICE_URLS: Record<ServiceName, string | undefined> = {
    pam: PUBLIC_PAM_CLIENT_API_URL,
    ntl: PUBLIC_NAUTILUS_CLIENT_API_URL,
    sqw: PUBLIC_SQUIDWARD_CLIENT_API_URL,
    cml: PUBLIC_CHAMELEON_CLIENT_API_URL,
    nrc: PUBLIC_NARCO_CLIENT_API_URL,
    neo: PUBLIC_NEO_CLIENT_API_URL,
    scr: PUBLIC_SCR_CLIENT_API_URL,
    'cml-v2': PUBLIC_CHAMELEON_V2_CLIENT_API_URL,
}

export const IS_ON_SERVER = typeof window === 'undefined'

export function getServiceUrl(serviceName: ServiceName): string | undefined {
    return SERVICE_URLS[serviceName]
}
